<prcins-card *ngIf="showSignUp" pt="pt-0">
  <div body>
    <prcins-notification [notification]="edocsEnrollmentNotification"></prcins-notification>
    <ng-container *ngIf="!isLoading; else loading">
      <ng-container *ngIf="!signUpSuccess">
        <div class="flex justify-center"><img src="assets/png/orange-tree.png" alt="tree" style="width:50px"></div>
        <p class="text-es-orange text-center text-xl font-semibold">We'll keep the paper, you save a tree!</p>
        <p class="text-center">Email my docs instead of sending piles of paper. I have read and agree to the <a
            href="https://www.plymouthrock.com/utility/terms-eDocs-popup" class="text-es-blue" target="_blank">terms &
            conditions</a> and I <a href="https://www.plymouthrock.com/internet-policy/consent-to-conduct"
            target="_blank" class="text-blue-600">Consent to Conduct Business Electronically.</a></p>
        <button class="mt-4 es-btn-primary" (click)="onSignUp()">Sign Me Up!</button>
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <prcins-skeleton  numOfRows="5"></prcins-skeleton>
    </ng-template>
  </div>
</prcins-card>